import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as lotesApi from '../../api/lotes';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { formatDate, formatDateTime } from '../../utils/date';

export default function LoteDetalhe() {
  const { id } = useParams();
  const [lote, setLote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    lotesApi
      .getLote(id)
      .then((r) => setLote(r.data))
      .catch(() => setErro('Erro ao carregar o lote.'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <LoadingSpinner />;
  if (erro) return <div className="sf-login-alert"><i className="bi bi-exclamation-circle" />{erro}</div>;

  return (
    <div>
      <PageHeader titulo={`Lote ${lote.codigo}`} subtitulo={`Recebido em ${formatDate(lote.data_entrada)}`} />

      <div className="sf-card p-4 mb-3">
        <div className="row g-3">
          <div className="col-md-4">
            <div className="sf-cell-sub mb-1">Produto</div>
            <div className="sf-cell-title">{lote.produto.nome}</div>
          </div>
          <div className="col-md-4">
            <div className="sf-cell-sub mb-1">Fornecedor</div>
            <div className="sf-cell-title">{lote.fornecedor.nome}</div>
          </div>
          <div className="col-md-4">
            <div className="sf-cell-sub mb-1">Criado em</div>
            <div className="sf-cell-title">{formatDateTime(lote.created_at)}</div>
          </div>
        </div>
        {lote.observacoes && (
          <div className="mt-3">
            <div className="sf-cell-sub mb-1">Observações</div>
            <div>{lote.observacoes}</div>
          </div>
        )}
      </div>

      <div className="sf-table-card">
        <div className="sf-table-toolbar">
          <span style={{ fontWeight: 800, fontSize: 15 }}>Qualidades recebidas</span>
        </div>
        <div className="table-responsive">
          <table className="sf-table">
            <thead>
              <tr>
                <th>Qualidade</th>
                <th>Quantidade recebida</th>
                <th>Saldo atual</th>
                <th>Unidade</th>
              </tr>
            </thead>
            <tbody>
              {lote.itens.map((item) => (
                <tr key={item.id_item_lote}>
                  <td>
                    <span className="d-flex align-items-center gap-2">
                      <span className="sf-cell-icon"><i className="bi bi-award" /></span>
                      <span className="sf-cell-title">{item.qualidade.nome}</span>
                    </span>
                  </td>
                  <td>{Number(item.quantidade_recebida)}</td>
                  <td>
                    <span style={Number(item.saldo_atual) === 0 ? { color: 'var(--sf-danger-fg)', fontWeight: 700 } : { fontWeight: 700 }}>
                      {Number(item.saldo_atual)}
                    </span>
                  </td>
                  <td>{item.unidade_medida.sigla}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
